// Last 8 searches, newest first, per browser. Never leaves the device.

const KEY = "athavita:mail:recent-searches";
const MAX = 8;

export function loadRecentSearches(): string[] {
    try {
        const raw = localStorage.getItem(KEY);
        const list = raw ? (JSON.parse(raw) as unknown) : [];
        return Array.isArray(list) ? list.filter((s): s is string => typeof s === "string").slice(0, MAX) : [];
    } catch {
        return [];
    }
}

export function addRecentSearch(query: string): string[] {
    const q = query.trim();
    if (!q) return loadRecentSearches();
    const next = [q, ...loadRecentSearches().filter((s) => s.toLowerCase() !== q.toLowerCase())].slice(0, MAX);
    try {
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // storage blocked
    }
    return next;
}

export function removeRecentSearch(query: string): string[] {
    const next = loadRecentSearches().filter((s) => s !== query);
    try {
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // storage blocked
    }
    return next;
}
